import { Dispatch } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'

import { Button, Card, Flex, Heading } from 'app/ui'

const useStyles = makeStyles(() => ({
    text: {
        margin: '20px 0',
        fontSize: '1.2rem',
    },

    buttonGroup: {
        justifyContent: 'space-around',
        width: '100%',
        margin: '20px 0',
    },
}))

type ConfirmDeletionProperties = {
    setWantsDelete: Dispatch<boolean>
    setHasConfirmedDeletion: Dispatch<boolean>
    isDeleting: boolean
}

/** Display confirmation message when the user wants delete. */
export const ConfirmDeletion = ({
    setWantsDelete,
    setHasConfirmedDeletion,
    isDeleting,
}: Readonly<ConfirmDeletionProperties>): JSX.Element => {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
        <Card>
            <Heading>{t('confirmDeletionTitle')}</Heading>

            <div className={classes.text}>{t('confirmDeletionText')}</div>

            <Flex className={classes.buttonGroup}>
                {/* Back button */}
                <Button
                    color='grey'
                    onClick={() => {
                        setWantsDelete(false)
                    }}
                    isDisabled={isDeleting}
                >
                    {t('back')}
                </Button>

                {/* Confirm button */}
                <Button
                    color='error'
                    onClick={() => {
                        setHasConfirmedDeletion(true)
                    }}
                    isPending={isDeleting}
                >
                    {t('delete')}
                </Button>
            </Flex>
        </Card>
    )
}
